import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import {
    Box,
    Button,
    Typography,
    makeStyles,
    MenuItem,
    Select,
    Container,
    FormControl,
    Stepper,
    Step,
    StepLabel,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Radio,
    RadioGroup
} from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';
import CloseIcon from '@material-ui/icons/Close';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import axios from 'axios';
import { useApiBaseUrl } from '../../common/CommonMethods/CommonMethods';
import { appUrl } from '../../../../../utils/config';
import StyledDialog from '../../../../common/models/Dialog';
import Dialog from '@material-ui/core/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserAssociation } from '../../../containers/actions/common/purchaseOrderAction';
import jwt_decode from 'jwt-decode';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    stepperHeader: {
        padding: "32px 0",
        textAlign: "center",
        backgroundColor: "#F5F9FF",
        position: "relative",
    },
    heading: {
        fontWeight: 600,
        fontSize: 38,
        lineHeight: "100%",
        marginBottom: 20,
    },
    subheading: {
        fontWeight: 400,
        fontSize: 24,
        lineHeight: "100%",
    },
    closePageAction: {
        position: "absolute",
        top: 20,
        right: 20,
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontWeight: "bold",
        color: "#000",
        "& svg": {
            marginLeft: 4,
            color: "red",
        },
    },
    uploadBox: {
        width: "100%",
        marginTop: "2em",
        border: "1px solid black",
        backgroundColor: "#f5f5f5",
        padding: "2em 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        minHeight: 60,
    },
    uploadText: {
        marginLeft: "auto",
        textAlign: "center",
        flex: 1,
        fontSize: 16,
    },
    uploadIcon: {
        fontSize: "40px",
        marginLeft: "auto",
        marginRight: "20px",
        color: "#333",
    },
    file: {
        marginTop: "2em",
        display: "flex",
        flexDirection: "column",
        gap: "1em",
        alignItems: "flex-start",
    },
    link: {
        color: "blue",
        textDecoration: "underline",
    },
    linkBox: {
        cursor: "pointer",
        display: "flex",
        gap: "0.5em",
    },
    bold: {
        fontWeight: 500,
    },
    criteria: {
        maxWidth: "500px",
    },
    uploadBtn: {
        backgroundColor: "#ec6535",
        color: "white",
        textTransform: "none",
        borderRadius: "50px",
        margin: "1em auto",
        padding: "5px 30px",
        "&:hover": {
            backgroundColor: "#ec6535",
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#ec6535",
    },
    filePreview: {
        marginLeft: theme.spacing(4),
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 8,
    },
    fileName: {
        color: "#2592f9",
        borderBottom: "2px solid #2592f9",
        paddingBottom: 2,
        cursor: "pointer",
    },
    fileSelect: {
        marginLeft: theme.spacing(4),
        marginBottom: theme.spacing(2),
        fontWeight: "bold"
    },
    uploadButton: {
        display: "flex",
        justifyContent: "center",
        margin: theme.spacing(4, 0),
    },
    uploadButtonStyle: {
        backgroundColor: '#ec6535',
        color: '#fff',
        borderRadius: 20,
        padding: '6px 24px',
        textTransform: 'none',
        display: 'flex',
        alignItems: 'center',
        fontSize: "16px",
        gap: 8,
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: '#c6532b',
        },
    },
    validationSummary: {
        padding: "2em",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        margin: "2em 0",
    },
    summaryItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1em",
        margin: "0.5em 0",
        borderRadius: "4px",
        backgroundColor: "white",
    },
    validCount: {
        color: "#4caf50",
        fontWeight: "bold",
    },
    invalidCount: {
        color: "#f44336",
        fontWeight: "bold",
    },
    totalCount: {
        color: "#2196f3",
        fontWeight: "bold",
    },
    container: {
        textAlign: "center",
        padding: "1rem"
    },
    itemGrid: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    number: {
        fontSize: "2.4rem",
        fontWeight: 500
    },
    totalRecordsBox: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    validRecordsBox: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    invalidRecordsBox: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: theme.spacing(3),
        width: "100%",
    },
    reUploadButton: {
        marginRight: "auto",
        alignSelf: "flex-start",
        textDecoration: "underline",
        cursor: "pointer",
        textTransform: "none",
    },
    selectionSection: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        border: "1px solid #e0e0e0",
        borderRadius: "4px",
        backgroundColor: "#ffffff",
    },
    sectionTitle: {
        fontWeight: 600,
        fontSize: "16px",
        marginBottom: theme.spacing(1.5),
        color: "#333",
    },
    checkboxGroup: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
    },
    checkboxItem: {
        margin: 0,
    },
    summaryBox: {
        backgroundColor: "#ffffff",
        border: "1px solid #e0e0e0",
        borderRadius: "4px",
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    summaryTitle: {
        fontWeight: 600,
        fontSize: "14px",
        marginBottom: theme.spacing(1),
        color: "#333",
    },
    summaryContent: {
        fontSize: "14px",
        color: "#666",
        lineHeight: 1.6,
        wordBreak: "break-word",
    },
    helperText: {
        backgroundColor: "#f5f5f5",
        padding: theme.spacing(1.5, 2),
        borderRadius: "4px",
        border: "1px solid #e0e0e0",
        marginBottom: theme.spacing(2),
        fontSize: "14px",
        color: "#666",
        lineHeight: 1.5,
    },
}));


const getSteps = () => ["Upload file", "Validation summary"];


const UploadPOs = () => {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);
    const [fileType, setFileType] = useState('xlsx');
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [hasUploadedSuccessfully, setHasUploadedSuccessfully] = useState(false);
    const [uploadErrors, setUploadErrors] = useState([]);
    const [invalidRecords, setInvalidRecords] = useState([]);
    const [apiMessage, setApiMessage] = useState("");
    const [error, setError] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [validationData, setValidationData] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);


    const isCMOUser = (typeof window !== 'undefined') && (localStorage.getItem('collabType') === 'CMO');

    // New state for CMO and column selection
    const [availableCMOs, setAvailableCMOs] = useState([]);
    const [selectedCMOIds, setSelectedCMOIds] = useState([]);
    // Default selection as per spec: Comments Section + PO-level Reason Code / Description
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [loadingCMOs, setLoadingCMOs] = useState(false);
    const [columnOptions, setColumnOptions] = useState([]);
    const [loadingColumns, setLoadingColumns] = useState(false);


    const fileInputRef = useRef();
    const API_BASE_URL = useApiBaseUrl(appUrl);
    const steps = getSteps();

    // Get user association data from Redux
    const userAssociationData = useSelector(
        (state) => state.pcmp?.common?.purchaseOrder?.userAssociationResult || null
    );


    // Function to extract columns from viewCMODetails API response
    const extractColumnsFromAPI = (responseData) => {
        try {
            const ingestionConfigs = responseData?.data?.vendorPlantDetails?.vendorPlantDetails?.ingestionConfigurations || [];
            
            // Find the config with category "PO Collaboration" and ingestThrough "Excel (download/upload through UI)"
            const poCollabConfig = ingestionConfigs.find(
                config => config.category === 'PO Collaboration' && 
                          config.ingestThrough === 'Excel (download/upload through UI)'
            );
            
            if (poCollabConfig && poCollabConfig.tabs && poCollabConfig.tabs[0]?.columns) {
                const columns = poCollabConfig.tabs[0].columns;
                return columns
                    .filter(col => col.fieldType?.toLowerCase() !== 'chain of custody') // Exclude Chain of custody fields
                    .map(col => ({
                        label: col.columnName,
                        key: col.dataElement.replace(/\s+/g, ''), // Remove spaces for key
                        dataElement: col.dataElement,
                        columnName: col.columnName,
                        ingestion: col.ingestion,
                        fieldType: col.fieldType
                    }));
            }
            return [];
        } catch (error) {
            console.error('Error extracting columns from API:', error);
            return [];
        }
    };


    const getEffectiveSelectedColumnKeys = (optionKeys) => {
        // Return the selected column keys (data elements with spaces removed)
        return optionKeys.map(key => {
            const column = columnOptions.find(col => col.key === key);
            return column ? column.columnName : key;
        });
    };



    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.name.endsWith('.xlsx')) {
            setFile(selectedFile);
            setUploadErrors([]);
            setInvalidRecords([]);
            setApiMessage("");
            setError(null);
        } else {
            alert('Please upload a .xlsx file');
        }
        e.target.value = "";
    };


    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile && droppedFile.name.endsWith('.xlsx')) {
            setFile(droppedFile);
            setUploadErrors([]);
            setInvalidRecords([]);
            setApiMessage("");
            setError(null);
        } else {
            alert('Please upload a .xlsx file');
        }
    };


    const handleDragOver = (e) => {
        e.preventDefault();
    };


    const handleRemoveFile = () => {
        if (isUploading) return;
        setFile(null);
        setUploadErrors([]);
        setInvalidRecords([]);
        setApiMessage("");
        setError(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };


    const handleUploadBoxClick = () => {
        if (!file || invalidRecords.length > 0 || uploadErrors.length > 0 || error) {
            fileInputRef.current.click();
        }
    };


    const getAcceptAttribute = (type) => {
        return ".xlsx, .xls";
    };


    // Fetch user associations and CMO members on component mount
    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (token) {
            try {
                const payload = jwt_decode(token);
                const userId = payload.saas_user_id;
               
                // Fetch user associations
                if (!userAssociationData && userId) {
                    dispatch(fetchUserAssociation(userId))
                        .catch((error) => {
                            console.error("Error fetching user associations:", error);
                        });
                }
            } catch (e) {
                console.error('Invalid token', e);
            }
        }
    }, [dispatch, userAssociationData]);


    // Fetch CMO members list
    useEffect(() => {
        if (!API_BASE_URL) {
            setLoadingCMOs(false);
            setAvailableCMOs([]);
            return;
        }

        setLoadingCMOs(true);
        const { collabType, roleName, organizationName, ecosystemId } = localStorage;
        const payload = {
            collabType,
            roleName,
            organizationName,
            ecosystemId,
        };

        axios
            .post(`${API_BASE_URL}/fetchCMOMembersDirect`, payload)
            .then((res) => {
                if (res.data?.status && res.data?.CMOMembersWithId) {
                    // Remove duplicates using Set based on organizationId
                    const uniqueCMOsMap = new Map();
                    res.data.CMOMembersWithId.forEach(cmo => {
                        if (!uniqueCMOsMap.has(cmo.organizationId)) {
                            uniqueCMOsMap.set(cmo.organizationId, cmo);
                        }
                    });
                    setAvailableCMOs(Array.from(uniqueCMOsMap.values()));
                } else {
                    setAvailableCMOs([]);
                }
            })
            .catch((err) => {
                console.error("Error fetching CMO members:", err);
                setAvailableCMOs([]);
            })
            .finally(() => {
                setLoadingCMOs(false);
            });
    }, [API_BASE_URL]);


    // Initialize selectedCMOIds with first user-associated CMO when data is available (only once)
    const hasInitializedCMOs = useRef(false);
    useEffect(() => {
        if (userAssociationData?.data?.associatedCMOList && availableCMOs.length > 0 && !hasInitializedCMOs.current) {
            // Remove duplicates from associatedCMOList using Set
            const uniqueAssociatedCMOIds = Array.from(new Set(userAssociationData.data.associatedCMOList));
           
            // Filter CMOs to only show those that are in the availableCMOs list and match user associations
            const filteredCMOs = availableCMOs.filter(cmo =>
                uniqueAssociatedCMOIds.includes(cmo.organizationId)
            );
           
            // Set selected CMO to first associated CMO by default (only on first initialization)
            if (filteredCMOs.length > 0) {
                const firstCMOId = String(filteredCMOs[0].organizationId);
                setSelectedCMOIds([firstCMOId]);
                hasInitializedCMOs.current = true;
                
                // Fetch columns for the first CMO
                fetchCMODetails(firstCMOId);
            }
        }
    }, [userAssociationData, availableCMOs]);


    // Fetch CMO Details and extract columns
    const fetchCMODetails = async (cmoId) => {
        if (!API_BASE_URL) {
            console.error('API_BASE_URL is not available');
            return;
        }
        
        setLoadingColumns(true);
        try {
            const viewCMODetailsRes = await axios.post(
                `${API_BASE_URL}/viewCMODetails`,
                {
                    cmoOrgId: cmoId,
                    ecosystemId: localStorage.getItem('ecosystemId'),
                }
            );
            
            // Extract columns from the response
            const extractedColumns = extractColumnsFromAPI(viewCMODetailsRes.data);
            setColumnOptions(extractedColumns);
            
            // Clear previously selected columns when CMO changes
            setSelectedColumns([]);
        } catch (error) {
            console.error('Error fetching CMO details:', error);
            setColumnOptions([]);
        } finally {
            setLoadingColumns(false);
        }
    };

    // Handle CMO selection change - single selection with radio button
    const handleCMOSelectionChange = async (cmoId) => {
        setSelectedCMOIds([cmoId]);
        await fetchCMODetails(cmoId);
    };





    // Handle column selection change
    const handleColumnSelectionChange = (columnKey, checked) => {
        if (checked) {
            setSelectedColumns(prev => [...prev, columnKey]);
        } else {
            setSelectedColumns(prev => prev.filter(key => key !== columnKey));
        }
    };


    // Get available CMOs (only user-associated ones) - remove duplicates
    const getAvailableCMOsForSelection = () => {
        if (!userAssociationData?.data?.associatedCMOList || availableCMOs.length === 0) {
            return [];
        }
        // Remove duplicates from associatedCMOList using Set
        const uniqueAssociatedCMOIds = Array.from(new Set(userAssociationData.data.associatedCMOList));
       
        // Filter and remove duplicates based on organizationId
        const seenIds = new Set();
        return availableCMOs.filter(cmo => {
            if (uniqueAssociatedCMOIds.includes(cmo.organizationId) && !seenIds.has(cmo.organizationId)) {
                seenIds.add(cmo.organizationId);
                return true;
            }
            return false;
        });
    };


    const handleNext = () => setActiveStep((prev) => prev + 1);
    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
        setHasUploadedSuccessfully(false);
        setValidationData(null);
    };


    const handleUpload = async () => {
        // Validation: Check if at least one CMO and one column is selected (BMS flow only)
        if (!isCMOUser) {
            if (selectedCMOIds.length === 0) {
                setError("Please select at least one CMO");
                return;
            }
            const effectiveColumns = getEffectiveSelectedColumnKeys(selectedColumns);
            if (effectiveColumns.length === 0) {
                setError("Please select at least one column");
                return;
            }
        }
        if (!file) {
            setError("Please select a file to upload");
            return;
        }


        if (file && !isUploading) {
            setIsUploading(true);
            setUploadErrors([]);
            setInvalidRecords([]);
            setApiMessage("");
            setError(null);
            try {
                const formData = new FormData();
                formData.append('files', file);


                // Only BMS-side flow uses explicit CMO/column selection payload
                if (!isCMOUser) {
                    const effectiveColumns = getEffectiveSelectedColumnKeys(selectedColumns);
                    formData.append('selectedCMOIds', JSON.stringify(selectedCMOIds));
                    formData.append('selectedColumns', JSON.stringify(effectiveColumns));
                }


                const response = await axios.post(`${API_BASE_URL}/uploadPODetails`, formData);
                const data = response.data;


                setIsUploading(false);


                if (data.invalidRecords && data.invalidRecords.length > 0) {
                    setInvalidRecords(data.invalidRecords);
                    setApiMessage(data.message || "");
                    setUploadErrors([]);
                    setHasUploadedSuccessfully(false);
                    setUploadSuccess(false);
                    setValidationData(data);
                    handleNext();
                } else if (data.status === false && (data.errorDescription)) {
                    setInvalidRecords([]);
                    setApiMessage("");
                    setUploadErrors([data.errorDescription].filter(Boolean));
                    setHasUploadedSuccessfully(false);
                    setUploadSuccess(false);
                } else {
                    setInvalidRecords([]);
                    setApiMessage("");
                    setHasUploadedSuccessfully(true);
                    setValidationData(data);
                    handleNext();
                }
            } catch (error) {
                setIsUploading(false);
                setInvalidRecords([]);
                setApiMessage("");
                if (error.response && error.response.data && (error.response.data.errorDescription)) {
                    setUploadErrors([
                        error.response.data.errorDescription
                    ].filter(Boolean));
                } else {
                    setUploadErrors(['An error occurred while uploading. Please try again.']);
                }
            }
        }
    };


    const handleSubmitValidRecords = async () => {
        if (!validationData?.validRecords || isSubmitting) return;


        setIsSubmitting(true);
        try {
            // TODO: Replace with actual PO submission endpoint
            const response = await axios.post(`${API_BASE_URL}/updatePODetailsExcel`, {
                validRecords: validationData.validRecords || [],
                chatOnlyRecords: validationData.chatOnlyRecords || []
            });


            if (response.data.status) {
                setUploadSuccess(true);
                setHasUploadedSuccessfully(true);
            } else {
                setError(response.data.errorDescription || "Submission failed.");
            }
        } catch (error) {
            const errMsg = error?.response?.data?.errorDescription ||
                "An error occurred during submission.";
            setError(errMsg);
        } finally {
            setIsSubmitting(false);
        }
    };


    const handleCloseDialog = () => {
        setUploadSuccess(false);
        setFile(null);
        setFileType('xlsx');
        setIsUploading(false);
        setHasUploadedSuccessfully(false);
        setUploadErrors([]);
        setInvalidRecords([]);
        setApiMessage("");
        setError(null);
        setActiveStep(0);
        setValidationData(null);
        setIsSubmitting(false);
        // Reset selections
        setSelectedColumns([]);
        setSelectedCMOIds([]);
        setColumnOptions([]);
        hasInitializedCMOs.current = false; // Reset initialization flag
        history.push(`/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/purchaseorderManagement`);
    };


    const handleGoBack = () => {
        history.goBack();
    };


    const displayError = (
        <Container
            style={{
                width: "100%",
                border: "2px solid red",
                backgroundColor: "#ffeaea",
                padding: "0.8rem",
                marginBottom: "1.5em",
                textAlign: "center",
                fontSize: "0.875rem",
            }}
        >
            <Typography variant="body2">{error}</Typography>
        </Container>
    );


    const getStepContent = (step) => {
        switch (step) {
            case 0:
                const availableCMOsForSelection = getAvailableCMOsForSelection();
                return (
                    <Container>
                        {error && displayError}
                        {uploadErrors.length > 0 && (
                            <Box mt={2} style={{ width: '100%' }}>
                                {uploadErrors.map((err, idx) => (
                                    <Container
                                        key={idx}
                                        style={{
                                            width: "100%",
                                            border: "2px solid red",
                                            backgroundColor: "#ffeaea",
                                            padding: "0.8rem",
                                            marginBottom: "0.5em",
                                            textAlign: "center",
                                            fontSize: "0.875rem",
                                        }}
                                    >
                                        <Typography variant="body2">{err}</Typography>
                                    </Container>
                                ))}
                            </Box>
                        )}
                        {invalidRecords.length > 0 && (
                            <Box mt={2} style={{ width: '100%' }}>
                                <Container
                                    style={{
                                        width: "100%",
                                        border: "2px solid red",
                                        backgroundColor: "#ffeaea",
                                        padding: "0.8rem",
                                        marginBottom: "0.5em",
                                        textAlign: "left",
                                        fontSize: "0.875rem",
                                    }}
                                >
                                    <Typography variant="subtitle2">Rejected record(s) error(s):</Typography>
                                    {invalidRecords.map((records, recordIndex) => (
                                        <React.Fragment key={recordIndex}>
                                            {records.errors.map((error, errorIndex) => (
                                                <Typography
                                                    key={`${recordIndex}-${errorIndex}`}
                                                    variant="body2"
                                                    gutterBottom
                                                    display="block"
                                                >{`Row ${records?.row} - ${error}`}</Typography>
                                            ))}
                                        </React.Fragment>
                                    ))}
                                </Container>
                            </Box>
                        )}


                        {/* CMO Selection Section - Top (BMS only) - Always show for BMS users */}
                        {!isCMOUser && (
                        <Box className={classes.selectionSection} style={{ marginBottom: "1.5rem" }}>
                            <Box style={{ marginBottom: "1rem" }}>
                                <Typography className={classes.sectionTitle}>
                                    {!loadingCMOs && availableCMOsForSelection.length === 1 
                                        ? "Associated CMO" 
                                        : "Select CMO"
                                    } <span style={{ color: "red" }}>*</span>
                                </Typography>
                            </Box>
                            {!loadingCMOs && availableCMOsForSelection.length > 1 && (
                                <Box className={classes.helperText}>
                                    <Typography variant="body2">
                                        Select the CMO that will be associated with your purchase orders.
                                    </Typography>
                                </Box>
                            )}
                            {loadingCMOs ? (
                                <Typography variant="body2" style={{ padding: "1rem 0" }}>
                                    Loading associated CMOs...
                                </Typography>
                            ) : availableCMOsForSelection.length === 0 ? (
                                <Typography variant="body2" color="error">
                                    No CMOs associated with your account
                                </Typography>
                            ) : (
                                <RadioGroup
                                    value={selectedCMOIds[0] ? String(selectedCMOIds[0]) : ''}
                                    onChange={(e) => handleCMOSelectionChange(e.target.value)}
                                >
                                    <Grid container spacing={2}>
                                        {availableCMOsForSelection.map((cmo) => {
                                            return (
                                                <Grid item xs={12} sm={6} md={4} lg={3} key={cmo.organizationId}>
                                                    <FormControlLabel
                                                        value={String(cmo.organizationId)}
                                                        control={<Radio color="primary" />}
                                                        label={cmo.organizationName || `CMO ID: ${cmo.organizationId}`}
                                                        className={classes.checkboxItem}
                                                    />
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </RadioGroup>
                            )}
                        </Box>
                        )}


                        {/* Column Selection Section - Bottom (BMS only) */}
                        {!isCMOUser && (
                        <Box className={classes.selectionSection} style={{ marginBottom: "1.5rem" }}>
                            <Typography className={classes.sectionTitle}>
                                Select Columns to be Uploaded <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <Box className={classes.helperText}>
                                <Typography variant="body2">
                                    Select the columns you want to include in your upload.
                                </Typography>
                            </Box>
                            {loadingColumns ? (
                                <Typography variant="body2" style={{ padding: "1rem 0" }}>
                                    Loading columns...
                                </Typography>
                            ) : columnOptions.length === 0 ? (
                                <Typography variant="body2" color="error">
                                    No columns available.
                                </Typography>
                            ) : (
                                <FormGroup className={classes.checkboxGroup}>
                                    {columnOptions.map((column) => (
                                        <FormControlLabel
                                            key={column.key}
                                            control={
                                                <Checkbox
                                                    checked={selectedColumns.includes(column.key)}
                                                    onChange={(e) => handleColumnSelectionChange(column.key, e.target.checked)}
                                                    color="primary"
                                                />
                                            }
                                            label={column.label}
                                            className={classes.checkboxItem}
                                        />
                                    ))}
                                </FormGroup>
                            )}
                        </Box>
                        )}


                        <Box
                            className={classes.uploadBox}
                            onClick={handleUploadBoxClick}
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            style={{
                                cursor: (!file || invalidRecords.length > 0 || uploadErrors.length > 0 || error) ? 'pointer' : 'not-allowed',
                                opacity: file && !(invalidRecords.length > 0 || uploadErrors.length > 0 || error) ? 0.6 : 1
                            }}
                        >
                            <input
                                type="file"
                                hidden
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                accept={getAcceptAttribute(fileType)}
                            />
                            <Typography className={classes.uploadText}>
                                Drag & drop file or click here to upload
                            </Typography>
                            <PublishIcon className={classes.uploadIcon} />
                        </Box>


                        <Box className={classes.file}>
                            <Typography>Select file type:</Typography>
                            <FormControl variant="outlined" size="small">
                                <Select
                                    value={fileType}
                                    onChange={(e) => setFileType(e.target.value)}
                                    disabled={file !== null && !(invalidRecords.length > 0 || uploadErrors.length > 0 || error)}
                                >
                                    <MenuItem value="xlsx">.xlsx</MenuItem>
                                </Select>
                            </FormControl>


                            {file && (
                                <Box className={classes.linkBox}>
                                    <Typography className={classes.link}>
                                        {file.name}
                                    </Typography>
                                    <span onClick={handleRemoveFile} style={{ cursor: "pointer" }}>
                                        ❌
                                    </span>
                                </Box>
                            )}

                            <Box>
                                <Typography className={classes.bold}>
                                    Validation criteria
                                </Typography>
                                <Typography className={classes.criteria}>
                                    Only excel files accepted (.xls, or .xlsx)
                                </Typography>
                                <Typography>First row must contain headers only</Typography>
                                <Typography>
                                    File should not contain blank rows or columns
                                </Typography>
                            </Box>


                            <Button
                                variant="contained"
                                className={classes.uploadBtn}
                                endIcon={<ChevronRightIcon />}
                                onClick={handleUpload}
                                disabled={
                                    !file || 
                                    isUploading || 
                                    hasUploadedSuccessfully || 
                                    invalidRecords.length > 0 || 
                                    (!isCMOUser && selectedCMOIds.length === 0) || 
                                    (!isCMOUser && selectedColumns.length === 0)
                                }
                            >
                                {isUploading ? 'Uploading...' : 'Upload'}
                            </Button>
                        </Box>
                    </Container>
                );
            case 1:
                // Prepare CMO and column summary for validation step (BMS flow only)
                const summaryCMOs = !isCMOUser ? (() => {
                    const available = getAvailableCMOsForSelection();
                    const names = available
                        .filter(cmo => selectedCMOIds.includes(String(cmo.organizationId)))
                        .map(cmo => cmo.organizationName || `CMO ID: ${cmo.organizationId}`);
                    return names.length > 0 ? names.join(", ") : "None selected";
                })() : null;


                const summaryColumns = !isCMOUser ? (() => {
                    const labels = columnOptions
                        .filter(col => selectedColumns.includes(col.key))
                        .map(col => col.label);
                    return labels.length > 0 ? labels.join(", ") : "None selected";
                })() : null;


                return (
                    <Container className={classes.container}>
                        {/* CMO and Columns Selection Summary - BMS only */}
                        {!isCMOUser && (
                            <Box style={{ marginBottom: "2rem" }}>
                                {/* CMO Selection Summary */}
                                <Box className={classes.summaryBox}>
                                    <Typography className={classes.summaryTitle}>
                                        CMO Selection
                                    </Typography>
                                    <Typography className={classes.summaryContent}>
                                        {summaryCMOs}
                                    </Typography>
                                </Box>




                                {/* Columns Selection Summary */}
                                <Box className={classes.summaryBox}>
                                    <Typography className={classes.summaryTitle}>
                                        Columns To Be Uploaded Selection
                                    </Typography>
                                    <Typography className={classes.summaryContent}>
                                        {summaryColumns}
                                    </Typography>
                                </Box>
                            </Box>
                        )}


                        <Typography variant="h5" style={{ marginBottom: "1em", fontWeight: 600 }}>
                            Validation Summary
                        </Typography>


                        {/* Summary of Records */}
                        <Grid container spacing={3} justify="space-between">
                            {[
                                {
                                    label: "Total Records",
                                    value: validationData?.validRecordsCount + validationData?.invalidRecordsCount || 0,
                                    className: classes.totalRecordsBox,
                                },
                                {
                                    label: "Valid Records",
                                    value: validationData?.validRecordsCount || 0,
                                    className: classes.validRecordsBox,
                                },
                                {
                                    label: "Rejected Records",
                                    value: validationData?.invalidRecordsCount || 0,
                                    className: classes.invalidRecordsBox,
                                },
                            ].map(({ label, value, className }, index) => (
                                <Grid item xs={12} sm={3} key={index}>
                                    <Box className={className}>
                                        <Typography>{label}</Typography>
                                        <Typography className={classes.number}>{value}</Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>


                        {/* Rejected Records */}
                        {invalidRecords.length > 0 && (
                            <Grid item xs={12}>
                                <Box width="100%" style={{ margin: "1em 0" }}>
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography variant="subtitle2">Rejected record(s) error(s)</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flexStart",
                                                textAlign: "left",
                                            }}
                                        >
                                            {invalidRecords.map((records, recordIndex) => (
                                                <React.Fragment key={recordIndex}>
                                                    {records.errors.map((error, errorIndex) => (
                                                        <Typography
                                                            key={`${recordIndex}-${errorIndex}`}
                                                            variant="body1"
                                                            gutterBottom
                                                            display="block"
                                                        >{`Row ${records?.row} - ${error}`}</Typography>
                                                    ))}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                            </Grid>
                        )}


                        <Box className={classes.buttonContainer}>
                            <Button className={classes.reUploadButton} onClick={handleBack}>
                                &lt; Re-upload File
                            </Button>
                            <Box style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    variant="contained"
                                    className={classes.uploadButtonStyle}
                                    onClick={handleSubmitValidRecords}
                                    disabled={isSubmitting || (validationData?.validRecordsCount || 0) === 0}
                                >
                                    {isSubmitting ? 'Submitting...' : 'Submit Records'}
                                    <ChevronRightIcon />
                                </Button>
                            </Box>
                        </Box>
                    </Container>
                );
            default:
                return <Typography>Unknown Step</Typography>;
        }
    };


    return (
        <Box className={classes.root}>
            <Box className={classes.stepperHeader}>
                <Typography className={classes.heading}>
                    Upload Purchase Orders
                </Typography>
                <Typography className={classes.subheading}>
                    Add / Update the list of purchase orders through the file
                </Typography>
                <Box className={classes.closePageAction} onClick={handleGoBack}>
                    <Typography style={{ fontWeight: 'bold', fontSize: "18px" }}>Cancel</Typography>
                    <CloseIcon />
                </Box>
            </Box>

            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            {getStepContent(activeStep)}

            {/* Success Dialog */}
            <Dialog open={uploadSuccess} fullWidth>
                <StyledDialog
                    icons={true}
                    handleClose={handleCloseDialog}
                    title={"Details Saved Successfully"}
                    subtitle={<>Your record has been added/updated.<br/> Please contact admin if you have entered the wrong data.</>}
                />
            </Dialog>
        </Box>
    );
};


export default UploadPOs;
